export const DEFAULT_MODEL = 'gpt-5';

export const AI_MODELS = {
    OPENAI: {
        name: 'OpenAI',
        models: [
            {
                id: 'gpt-5',
                label: 'gpt 5',
                description: 'Latest OpenAI model, great for most tasks',
                isRecommended: true,
                isImageSupported: true,
                isReasoning: false,
            },
            {
                id: 'gpt-5-thinking',
                label: 'gpt 5 thinking',
                description: 'Most powerful OpenAI reasoning model for complex challenges (slower and more expensive)',
                isImageSupported: true,
                isReasoning: true,
            },
            {
                id: 'gpt-5-mini',
                label: 'gpt 5 mini',
                description: 'Affordable model balancing speed and intelligence',
                isImageSupported: true,
                isReasoning: false,
            },
            /* {
                id: 'gpt-4.1',
                label: 'gpt 4',
                description: 'Previous OpenAI model (gpt-4.1)',
                isImageSupported: true,
                isReasoning: false,
            },
            {
                id: 'o3',
                label: 'o3',
                description: 'Powerful OpenAI reasoning model for complex tasks',
                isImageSupported: true,
                isReasoning: true,
            }, */
        ],
    },
    /*
    ANTHROPIC: {
        name: 'Anthropic',
        models: [
            {
                id: 'claude-4.5-sonnet',
                label: 'Claude 4.5 Sonnet',
                description: 'Great Claude model for most tasks',
                isRecommended: true,
                isImageSupported: true,
                isReasoning: false,
            },
            {
                id: 'claude-4.1-opus',
                label: 'Claude 4.1 Opus',
                description: 'Most powerful Claude model for complex challenges (more expensive)',
                isImageSupported: true,
                isReasoning: false,
            },
            {
                id: 'claude-4.5-sonnet-thinking',
                label: 'Claude 4.5 Sonnet Thinking',
                description: 'Claude 4.5 Sonnet with reasoning capabilities',
                isImageSupported: true,
                isReasoning: true,
            },
            {
                id: 'claude-4.1-opus-thinking',
                label: 'Claude 4.1 Opus Thinking',
                description: 'Claude 4.1 Opus with reasoning capabilities',
                isImageSupported: true,
                isReasoning: true,
            },
        ],
    },
    */
};

export function getModelConfig(modelId) {
    for (const provider of Object.values(AI_MODELS)) {
        const model = provider.models.find(m => m.id === modelId || m.providerModelId === modelId);
        if (model) return model;
    }
    return null;
}
